module.exports = __webpack_public_path__ + "af.svg?1e73c9eec7a1fe8d8a4a28de746bb09c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/af.svg
// module id = 1214
// module chunks = 0